<template>
	<div id="download-banner">
		<div class="uk-section uk-padding-remove-top uk-padding-remove-bottom">
			<div class="uk-container container" style="min-height: -webkit-fill-available;">
				<div class="uk-flex uk-flex-middle uk-grid uk-margin-medium-top" 
					uk-grid
					uk-scrollspy="cls: uk-animation-fade; target: > div; delay: 500; repeat: false;">
					
					<div class="uk-width-1-2@s" uk-scrollspy-class="uk-animation-slide-left">
						<div style="overflow: hidden;" class="image-container">
							<img src="../assets/iphone_x2.png" alt="../iphone_x2.png">
						</div>
					</div>

					<div class="uk-width-1-2@s uk-width-1-2@l uk-margin-auto-left uk-padding-remove" 
						uk-scrollspy-class="uk-animation-slide-right">
						<div class="uk-margin-auto-vertical uk-text-right uk-text-middle text-container" style="padding-left:30px;">
							<div>
								<h3 class="uk-text-uppercase">APP CONTROL</h3>
							</div>

							<div class="uk-margin-medium-bottom">
								<p>With the Roomi app you can monitor your home security from anywhere at any time.</p>
							</div>
							
							<div>
								<h5 class="uk-text-uppercase uk-margin-small-bottom">AVAILABLE ON IOS & ANDROID</h5>
							</div>
							
							<div id="button-wrap">
								<button style="cursor: pointer;">
									<div class="icon-wrapper">
										<img src="../assets/apple.svg" alt="../apple.svg" style="color: #FFF;" height="30" width="30" uk-svg>
									</div>
									<div class="text-wrapper uk-margin-auto-vertical">
										<span>DOWNLOAD FOR</span>
										<span>APPLE iOS</span>
									</div>
								</button>

								<button style="cursor: pointer;">
									<div class="icon-wrapper uk-margin-auto-vertical">
										<img src="../assets/android-logo.svg" alt="../android-logo.svg" style="color: #FFF;" height="30" width="30" uk-svg>
									</div>
									<div class="text-wrapper">
										<span>DOWNLOAD FOR</span>
										<span>ANDROID</span>
									</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			bgImage: require('../assets/1054974.jpg')
		}
	},
	mounted() {
		
	}
}
</script>

<style scoped>
#download-banner .uk-section {
	background-image: linear-gradient(to left, rgba(45, 61, 120, 0.9) 80%, rgb(45, 61, 120)), url('../assets/1054974.jpg');
	background-size: 100%;
	background-repeat: no-repeat;
	background-position: center;
}

.image-container {
	overflow: hidden;
}

.image-container img {
	transform: scale(0.9);
	transform-origin: top;
	margin-bottom: -65px;
}

.text-container h3, .text-container p, .text-container h5 {
	color: #FFF;
	font-weight: lighter;
}

.text-container h3 {
	font-size: 1.2rem;
	letter-spacing: 2px;
}

.text-container p {
	letter-spacing: 1px;
}

#button-wrap {
	display: flex;
	float: right;
}

#button-wrap button {
	display: inline;
	background-color: rgba(56, 88, 136, 0.6);
	border: unset;
	border-radius: 10px;
	padding: 10px 20px;
	align-items: center;
}

#button-wrap button:nth-child(1) {
	margin-right: 10px;
	display: inline-flex;
}

#button-wrap button:nth-child(2) {
	margin-left: 10px;
	display: inline-flex;
}

#button-wrap .text-wrapper {
	display: grid;
	margin-left: 10px;
}

#button-wrap .text-wrapper span:nth-child(1) {
	color: rgb(255, 255, 255);
	font-size: 10px;
}

#button-wrap .text-wrapper span:nth-child(2) {
	color: rgb(255, 255, 255);
	font-size: 17px;
}

@media screen and (max-width: 639px) {
	.image-container {
		overflow: visible !important;
	}

	.text-container h3, .text-container p, .text-container h5 {
		text-align: center !important;
	}

	p {
		margin-left: 0 !important;
	}

	#button-wrap {
		float: none;
	}

	#button-wrap button {
		margin: auto;
	}
}

@media screen and (min-width: 640px) and (max-width: 960px) {
	#button-wrap button {
		display: inline-block !important;
		margin-bottom: 25px;
	}
}

@media screen and (max-width: 768px) {
	.container {
		padding-bottom: 2% !important;
	}

	.image-container img {
		transform: scale(1) !important;
		width: 100%;
		height: auto !important;
	}
}

@media screen and (max-width: 960px) {
	.image-container img {
		transform: unset !important;
		margin-bottom: auto !important;
	}
}
</style>